import React from 'react';
import { X, UserCog } from 'lucide-react';
import PersonaPickerMiembro from './PersonaPickerMiembro';

/**
 * SelectorResponsable — elige UNA persona interna (el responsable directo de un alta o de una tarea).
 *
 * ENVUELVE `PersonaPickerMiembro` sin modificarlo. Aquel es un autocomplete de "añadir uno a uno":
 * dispara `onAdd(persona)` y se limpia para el siguiente, porque su caso es una lista de miembros de
 * área. Aquí el caso es un valor ÚNICO, así que este envoltorio:
 *   - mientras no hay nadie elegido, muestra el picker tal cual;
 *   - en cuanto `onAdd` dispara, guarda esa persona y sustituye el picker por un chip con su nombre
 *     y una X para limpiarlo.
 *
 * Se envuelve en vez de tocar el picker porque ese componente ya lo usan Areas.jsx y Avisos.jsx:
 * cambiarle el contrato para este caso les cambiaría el comportamiento a los dos.
 *
 * props: valor:{id,nombre}|null · onChange(persona|null) · label · disabled · placeholderVacio
 */
export default function SelectorResponsable({ valor, onChange, label = 'Responsable', disabled = false, placeholderVacio }) {
  return (
    <div>
      {label && (
        <span className="mb-1 block text-[11px] font-medium uppercase tracking-wide text-v25-ink-400">{label}</span>
      )}
      {valor ? (
        <div className="flex items-center gap-2 rounded-v25-md border border-v25-line bg-white px-2.5 py-1.5">
          <UserCog className="h-4 w-4 shrink-0 text-v25-brand-500" />
          <span className="min-w-0 flex-1 truncate text-sm text-v25-ink-900">{valor.nombre}</span>
          {!disabled && (
            <button
              type="button"
              onClick={() => onChange(null)}
              className="shrink-0 text-v25-ink-400 hover:text-red-600"
              aria-label={`Quitar a ${valor.nombre} como responsable`}
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      ) : (
        <>
          <PersonaPickerMiembro onAdd={(p) => onChange(p)} excluirIds={[]} disabled={disabled} />
          {placeholderVacio && <p className="mt-1 text-[11px] text-v25-ink-400">{placeholderVacio}</p>}
        </>
      )}
    </div>
  );
}
